import { useSnapshot } from "valtio";
import { state } from "../store";
import "./EnvironmentPanel.css";

export default function EnvironmentPanel() {
  const snap = useSnapshot(state);

  const isOpen = snap.openedPanel === "environment";

  const handleClose = () => {
    state.openedPanel = null;
  };

  // Define environment presets with HDRI URLs and background intensities
  const environmentPresets = [
    {
      name: "Midday",
      hdriUrl:
        "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/kloppenheim_06_puresky_2k.hdr",
      backgroundIntensity: 0.3,
      colors: {
        sky: "#87CEEB", // Sky blue
        sun: "#FFD700", // Gold sun
        clouds: "#FFFFFF", // White clouds
        horizon: "#F0F8FF", // Alice blue
        atmosphere: "#E0F6FF", // Light blue atmosphere
      },
    },
    {
      name: "Clarens",
      hdriUrl:
        "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/clarens_midday_2k.hdr",
      backgroundIntensity: 0.8,
      colors: {
        sky: "#87CEEB", // Sky blue
        sun: "#FFD700", // Gold sun
        clouds: "#FFFFFF", // White clouds
        horizon: "#F0F8FF", // Alice blue
        atmosphere: "#E0F6FF", // Light blue atmosphere
      },
    },
    {
      name: "Sunset",
      hdriUrl:
        "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/kiara_2_sunrise_2k.hdr", // Placeholder - you can change later
      backgroundIntensity: 0.05,
      colors: {
        sky: "#FF6B6B", // Coral red
        sun: "#FF8C00", // Dark orange
        clouds: "#FFB6C1", // Light pink
        horizon: "#FFA07A", // Light salmon
        atmosphere: "#FFE4E1", // Misty rose
      },
    },
    {
      name: "Night",
      hdriUrl:
        "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/rural_evening_road_2k.hdr", // Placeholder - you can change later
      backgroundIntensity: 0.5,
      colors: {
        sky: "#191970", // Midnight blue
        sun: "#FFFFFF", // White moon
        clouds: "#2F2F2F", // Dark gray
        horizon: "#000080", // Navy blue
        atmosphere: "#1C1C1C", // Dark atmosphere
      },
    },
    {
      name: "Dawn",
      hdriUrl:
        "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/golden_gate_hills_2k.hdr", // Placeholder - you can change later
      backgroundIntensity: 1.5,
      colors: {
        sky: "#FFB6C1", // Light pink
        sun: "#FFA500", // Orange
        clouds: "#FFC0CB", // Pink
        horizon: "#FFE4E1", // Misty rose
        atmosphere: "#FFF0F5", // Lavender blush
      },
    },
    {
      name: "Storm",
      hdriUrl:
        "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/qwantani_night_2k.hdr", // Placeholder - you can change later
      backgroundIntensity: 0.015,
      colors: {
        sky: "#708090", // Slate gray
        sun: "#D3D3D3", // Light gray
        clouds: "#696969", // Dim gray
        horizon: "#2F4F4F", // Dark slate gray
        atmosphere: "#36454F", // Charcoal
      },
    },
  ];

  const applyEnvironment = (preset) => {
    // Store environment preset
    state.environmentPreset = preset.name;
    state.environmentColors = preset.colors;
    state.environmentHdriUrl = preset.hdriUrl;
    state.environmentBackgroundIntensity = preset.backgroundIntensity;

    // Do NOT close panel automatically - let user close manually
  };

  return (
    <>
      {isOpen && (
        <>
          <h2 className="panel-title panel-title-presets">ENVIRONMENT</h2>
          <div className="environment-wrapper">
            <div className="environment-panel">
              <div className="environment-grid">
                {environmentPresets.map((preset, index) => (
                  <div
                    key={index}
                    className="environment-item"
                    onClick={() => applyEnvironment(preset)}
                  >
                    <div
                      className="environment-gradient-ball"
                      style={{
                        "--color1": preset.colors.sky,
                        "--color2": preset.colors.sun,
                        "--color3": preset.colors.clouds,
                        "--color4": preset.colors.horizon,
                        "--color5": preset.colors.atmosphere,
                      }}
                    ></div>
                  </div>
                ))}
              </div>
              <button
                className="close-button-environment"
                onClick={handleClose}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
